import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n'
import { changeLocaleDateTime } from '../components/helpers/datetime'
import { getLanguage } from '../components/helpers/language'
import {
  debounceSetStoragePersistData,
  reducers,
  setChangeListener,
} from '../components/helpers/reducerRegistry'
import { i18n } from '../components/lang/i18n'

export const store = configureStore({
  reducer: combineReducers({
    i18n: i18nReducer,
    ...reducers,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools: process.env.REACT_APP_ENV !== 'production',
})

store.subscribe(() => {
  debounceSetStoragePersistData(store)
})

setChangeListener((reducers) => {
  store.replaceReducer(
    combineReducers({
      i18n: i18nReducer,
      ...reducers,
    }),
  )
})

syncTranslationWithStore(store)
store.dispatch(loadTranslations(i18n))
store.dispatch(setLocale(getLanguage()))
changeLocaleDateTime(getLanguage())
